import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

export const LiveShoppingPage = lazy(
  () =>
    import('./LiveShopping.eager').then(mod => ({
      default: mod.LiveShoppingPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
